import { useContext, useEffect, useState } from 'react';
import { Box, Stack, Typography, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Popper } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Form } from './form/Index';
import { ToolContext } from '../../../../core/context/ToolContext';
import { useHistory } from 'react-router-dom';
import { rqx } from '../../../../core/request/API';
import { env, domain } from '../../../../core/Env';
import { List2 } from '../../../../core/global/Icons';
import { DirectTabLoader } from '../../../../core/loader/DirectTabLoader';
import { Confirmation } from '../../../../core/global/realproperty/Index';
import { SuccessMsg } from '../../../../core/global/SuccessMsg';
import { SnakeLoader } from '../../../../core/loader/SnakeLoader';
import Currency from 'react-currency-format';

export const MyPropertyListing = ({ match }) => {
    const { realproperty_state, tool_state } = useContext(ToolContext);
    const { myPrptyLstngs, mainInfrmtn, otherInfrmtn, dfltMainInfrmtn, dfltOtherInfrmtn } = realproperty_state
    const company_id = tool_state.__SESSION.data.uaccess[0].company_id;
    const user_id = Number(window.atob(tool_state.__SESSION.data.ainfo.aid).split('_').pop());
    const nav = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedId, setSelectedId] = useState(null);

    const backHandler = () => {
		nav.push('/realproperty/property-listing')
	}

    const __init = async () => {
        myPrptyLstngs.set((p) => ({ ...p, listLoader: true }))
        try {
            const res_list = await rqx.get(`<<tool>>/${env()}/propertyListing/read_my_property`, { company_id: company_id })
            if ( res_list ) {
                myPrptyLstngs.set((p) => ({ ...p, list: res_list, listLoader: false }))
            }
        } catch (error) {
            console.error("Failed to fetch data", error);
        }
    }
    //listLoader
    useEffect(() => {
        __init();
        // eslint-disable-next-line
    }, [])

    const handleCreate = () => {
        mainInfrmtn.set(dfltMainInfrmtn.data)
        otherInfrmtn.set(dfltOtherInfrmtn.data)
        nav.push(`/realproperty/setup?method=create`);
    }

    const cleanJsonNumbers = (jsonStr) => {
        return JSON.stringify(
            Object.fromEntries(
                Object.entries(JSON.parse(jsonStr)).map(([k, v]) => [
                    k,
                    typeof v === 'string' && v.includes(',')
                    ? parseInt(v.replace(/,/g, ''), 10)
                    : v,
                ])
            )
        );
    }

    const handleMouseEnter = (event, id) => {
        setAnchorEl(event.currentTarget);
        setSelectedId(id);
    };

    const handleMouseLeave = () => {
        setAnchorEl(null);
        setSelectedId(null);
    };

    const open = Boolean(anchorEl);

    useEffect(() => {
        setAnchorEl(null);
        setSelectedId(null);
    }, [match.params.type]);

    const handleModal = (id, v) => {
        myPrptyLstngs.set((p) => ({ ...p, 
            id,
            modal: v === 'disabled' || v === 'enable' || v === 'post',
            status: v === 'disabled' ? 1 : 0,
            type: v
        }))
    }

    const handleUpate = (id) => {
        nav.push(`/realproperty/setup?method=update&id=${window.btoa(`prm_${id}`)}`);
    }

    const handleView = async (id, status) => {
        const s = status === 1 ? 'saved' : 'posted'
        let ssoUrls = `${domain('shp').url}${`/psl/real-property/view?type=${s}&id=${window.btoa(`prm_${id}`)}`}`
        await DirectTabLoader('ShpWN', ssoUrls)
    }

    const handleUpdateActive = async () => {
        myPrptyLstngs.set((p) => ({ ...p, loader: true }))
        try {
            const body = {
                id: myPrptyLstngs.data.id,
                ref: 'status',
                user_id: user_id,
                status: myPrptyLstngs.data.type === 'disabled' ? 3 : 2,
            }
            const res = await rqx.post(`<<tool>>/${env()}/propertyListing/update_status`, body)
            if (res.message === 'success') {
                myPrptyLstngs.set((p) => ({ ...p, 
                    loader: false, 
                    success: true,
                    modal: false,
                    list: p.list.map(v => v.id === myPrptyLstngs.data.id ? { ...v, status: body.status, active: body.status === 3 ? 0 : 1} : v)
                }))
            }
        }  catch (err) {
            console.error("Failed to update status", err);
        } 
    }

    return (
        <Box>
            { match.params.type === "property-listing" ? 
                    myPrptyLstngs.data.listLoader ? 
                        <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box>
                    :
                        myPrptyLstngs.data.list.length === 0 ?
                        <Box display="flex" justifyContent="center">
                            <Box bgcolor="#fff" borderRadius={2} height={200} mt={10} p={4} sx={{ border: '1px solid' }}>
                                <Box height="50%" >To create your real property list click the Create Real Property button below.</Box>
                                <Box display="flex" justifyContent={"center"}>
                                    <Box width={300} height={49} component={Button} variant='contained' onClick={() => handleCreate()}>Create Real Property</Box>
                                </Box>
                            </Box>
                        </Box>
                        :
                        <>  
                            <Stack justifyContent='end' flexDirection="row">
                                <Box component={Button} variant='contained' onClick={() => handleCreate()} my="1rem" width='fit-content'>
                                    Create Real Property
                                </Box>
                            </Stack>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 700 }}>
                                    <TableHead sx={(theme) => ({ bgcolor: theme.palette.primary.main })}>
                                        <TableRow>
                                            <TableCell align="center" sx={{ color: "white", width: "4rem", }}>No.</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Title</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Property Type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Offer Type</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Price</TableCell>
                                            <TableCell align="left" sx={{ color: "white" }}>Status</TableCell>
                                            <TableCell align="center" sx={{ color: "white", width: "6rem" }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {myPrptyLstngs.data.list?.map((v, k) => (
                                        <TableRow key={k}>
                                            <TableCell component="th" scope="row" align="center"> 
                                                {myPrptyLstngs.data.list.length - k}
                                            </TableCell>
                                            <TableCell align="left">{v.name}</TableCell>
                                            <TableCell align="left">{v.property_type_name}</TableCell>
                                            <TableCell align="left">{v.offer_type === 1 ? "Sell" : v.offer_type === 2 ? "Rent" : "Unknown Offer Type"}</TableCell>
                                            <TableCell align="left">
                                                {v.offer_type === 1 && <Typography color="#757575">₱&nbsp;<Currency displayType={'text'} thousandSeparator={true} value={parseFloat(JSON.parse(cleanJsonNumbers(v.price)).price).toFixed(2)} /></Typography>}
                                                {v.offer_type === 2 &&
                                                    <Box display="flex" alignItems="center" gap={2} color="#4CAF50">
                                                        <Box display="flex" alignItems="center" flexDirection="column">Monthly <Box fontSize={14} color="#e23a08">₱&nbsp;
                                                            <Currency displayType={'text'} thousandSeparator={true} value={parseFloat(JSON.parse(cleanJsonNumbers(v.price)).monthly).toFixed(2)} />
                                                        </Box>
                                                        </Box>
                                                        <Box display="flex" alignItems="center" flexDirection="column"> Yearly <Box fontSize={14} color="#52D3D8">₱&nbsp;
                                                            <Currency displayType={'text'} thousandSeparator={true} value={parseFloat(JSON.parse(cleanJsonNumbers(v.price)).yearly).toFixed(2)} />
                                                        </Box>
                                                        </Box>
                                                    </Box>
                                                }
                                            </TableCell>
                                            <TableCell align="left">
                                                { <Box px="0.5rem" sx={{ borderRadius: "8px", width: "fit-content" }}
                                                    color={v.status === 1 ? '#009F4D' : v.status === 2 ? '#0876F8' : '#333'}
                                                    bgcolor={v.status === 1 ? '#CEFFDC' : v.status === 2 ? '#AFD4FF' : '#D9D9D9'}>
                                                    {v.status === 1 ? 'Saved' : v.status === 2 ? 'Posted' : v.status === 3 ? 'Disabled' : 'Unknown Status' }
                                                </Box> }
                                            </TableCell>
                                            <TableCell align="center">
                                                <Box
                                                    onMouseEnter={(e) => handleMouseEnter(e, v.id)}
                                                    onMouseLeave={() => handleMouseLeave()}
                                                    sx={{ display: 'inline-block', cursor: 'pointer' }}
                                                >
                                                    <Box display="flex" flexDirection="row-reverse" width="100%">
                                                        <Box width="100%" component={Button}>
                                                            <List2 fill="#333" width={20} />
                                                        </Box>
                                                    </Box>
                                                    <Popper open={open && selectedId === v.id} anchorEl={anchorEl} placement="bottom-end">
                                                        <Paper sx={{ mt: -1, width: 180, borderRadius: 2, py: "0.5rem" }}>
                                                            {v.status === 1 && (
                                                                <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => handleModal(v.id, 'post')}>
                                                                    Post
                                                                </Box>
                                                            )}
                                                            {v.status !== 3 && (
                                                                <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => handleUpate(v.id)}>
                                                                    Update
                                                                </Box>
                                                            )}
                                                            {v.status === 2 && (
                                                                <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => handleModal(v.id, 'disabled')}>
                                                                    Disable
                                                                </Box>
                                                            )}
                                                            {v.status === 3 && (
                                                                <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => handleModal(v.id, 'enable')}>
                                                                    Enable
                                                                </Box>
                                                            )}
                                                            <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => handleView(v.id, v.status)}>
                                                                View
                                                            </Box>
                                                        </Paper>
                                                    </Popper>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            { myPrptyLstngs.data.modal && <Confirmation isOpen={myPrptyLstngs.data.modal} cancel={() => handleModal('close')} send={() => handleUpdateActive()} disabled={myPrptyLstngs.data.loader} status={myPrptyLstngs.data.status} dsbldTxt={ <> This will not be available online. </> } enbldTxt={ <> This property will be listed on <b>POFShop</b>, making it easily accessible for your potential clients to view. You can still make updates even after it has been published. </> } enbldTitle = "Post this Property?"/> }
                        </>
            :
                <>
                    <Stack alignItems="center" flexDirection="row" gap="0.5rem" mt="0.5rem"s width="fit-content" p="0.25rem" sx={{ borderRadius: "8px", ":hover": { bgcolor: "#E2ECF3" }, cursor: 'pointer', transition: '0.25s' }} onClick={() => backHandler()}>
                        <ArrowBack sx={{ color: "primary.main", fontSize: "1rem" }}/>
                        <Typography fontSize='0.75rem'>Back</Typography>
                    </Stack>
                    <Box ml="1.7rem">
                        <Typography fontWeight={600} fontSize={22}>Enter Your Property Information for Buyer Review</Typography>
                        <Form company_id={company_id} user_id={user_id}/>
                    </Box>
                </>
            }
            { myPrptyLstngs.data.success && <SuccessMsg open={myPrptyLstngs.data.success} setOpen={(v) => myPrptyLstngs.set(p => ({ ...p, success: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={2000}/> }
        </Box>
    )
}
